import React, {useRef, useState, useEffect} from 'react';
import * as S from './MobilePop.styles';
import OTPBlock from '../../../../../../../../onboarding/src/stories/components/UI/OTP/otp';

const MobilePop = ({userNumber, resendOtp, clickActive, closePop, errorUnlinkOtp, submitOtp}) => {
  const otpRef = useRef(null);

  const [showError, setShowError] = useState('');

  const submitUserOtp = (event: React.FormEvent) => {
    event.preventDefault();
    const otpStr = otpRef.current.value;
    submitOtp(otpStr);
  };

  useEffect(() => {
    if (errorUnlinkOtp !== '') {
      setShowError(errorUnlinkOtp);
    }
  }, [errorUnlinkOtp]);

  return (
    <S.MobileVerifyPopWrap>
      <S.MobileVerifyPopContentWrap>
        <S.MobileVerifyPopHeadWrap>
          <S.PopBackBtn onClick={closePop}>Close</S.PopBackBtn>
        </S.MobileVerifyPopHeadWrap>
        <S.MobileVerifyBodyWrap>
          <S.VerifyForm onSubmit={submitUserOtp}>
            <S.MobileVerifyBodyHeadWrap>
              <S.MobileVerifyMainText>Unmask details</S.MobileVerifyMainText>
              <S.MobileVerifyInfoWrap>
                <S.MobileVerifyInfoText>
                  OTP has been sent to your mobile number +91{userNumber}
                </S.MobileVerifyInfoText>
              </S.MobileVerifyInfoWrap>
              <S.OptBlockWrap>
                <OTPBlock
                  ref={otpRef}
                  label=""
                  subLabel=""
                  otpLength={6}
                  type="aadhar_number"
                  resendOTP={() => resendOtp()}
                  autoFocus={true}
                  resendVisible={clickActive}
                />
                {(showError && <S.ErrorText>{showError}</S.ErrorText>) || null}
              </S.OptBlockWrap>
              <S.OtpFooterBtnWrap>
                <S.CancelBtn onClick={closePop}>Cancel</S.CancelBtn>
                <S.SubmitBtn type="submit">Verify</S.SubmitBtn>
              </S.OtpFooterBtnWrap>
            </S.MobileVerifyBodyHeadWrap>
          </S.VerifyForm>
        </S.MobileVerifyBodyWrap>
      </S.MobileVerifyPopContentWrap>
    </S.MobileVerifyPopWrap>
  );
};

export default MobilePop;
